module.exports = __webpack_public_path__ + "static/media/template_image.10c5c3e2.png";